<template>
  <div>
    <div class="wrapper" v-if="!loading">
      <header-vue />
      <section-vue :birthday-needed="false" />
      <footer-vue />
    </div>
    <transition name="fade">
      <div class="loader-container" v-if="loading">
        <loader-vue />
      </div>
    </transition>
  </div>
</template>

<script>
import LoaderVue from "../../Appointment/common/Loader.vue";
import FooterVue from "../../common/Footer.vue";
import HeaderVue from "./Header.vue";
import SectionVue from "./Section.vue";
import { authMixin } from "../../../mixins/authMixin";
import { addNewHomeMixin } from "../../../mixins/addNewHomeMixin";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  mixins: [authMixin, addNewHomeMixin],
  computed: {
    ...mapGetters({
      getAppointmentSubmitted: "getAppointmentSubmitted", // Check if appointent has been submitted and page can be changed
      loading: "getIsLoadingAddAppointment" // Should loading screen be shown
    })
  },
  methods: {
    ...mapActions({
      getFormDetails: "getFormDetails" // Get form details from the server
    }),
    ...mapMutations("addNew", {
      clearNew: "clear"
    }),
    ...mapMutations("group", {
      clearGroup: "clear"
    })
  },
  components: {
    LoaderVue,
    HeaderVue,
    FooterVue,
    SectionVue
  },
  created() {
    this.getFormDetails();
  },
  destroyed() {
    this.clearNew();
    this.clearGroup();
  }
};
</script>

<style scoped>
section {
  margin-top: 91px;
  margin-bottom: 45px;
}
.username-top img {
  max-width: 40px;
  float: left;
}
</style>
